/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { axiosInstance } from "../Axios/https";
import { loadStripe } from "@stripe/stripe-js";
import {
  Elements,
  CardElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Loader from "./Loader/Loader";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import OvalLoader from "./Loader/OvalLoader";
import Swal from 'sweetalert2'

// Stripe Code Start
const stripePromise = loadStripe(
  "pk_test_51JxnI9IHNyzY6LeMyC6IVsIoj4KeJYcuO3H2tL5UBE0thOu4DMFBGB12IR6B1ikH6vWcllMDV6jPtTL6blyoG0FK00Qm0Cipwv"
);

const CheckoutForm = ({ handleClose, id }) => {
  const [loaders, setLoader] = useState(false);
  const stripe = useStripe();
  const elements = useElements();

  const handleSubmit = async (event) => {
    setLoader(true);
    event.preventDefault();
    if (!stripe || !elements) {
      return;
    }
    const cardElement = elements.getElement(CardElement);
    const result = await stripe.createPaymentMethod({
      type: "card",
      card: cardElement,
    });
    if (result.error) {
      console.log(result.error.message);
      setLoader(false);
    } else {
      const paymentMethodId = result.paymentMethod.id;
      axiosInstance
        .post(
          "/client/subscribe/to/plan/stripe",
          {
            payment_method: paymentMethodId,
            plan_id: id,
          },
          {
            headers: {
              "Content-Type": "application/json",
              "X-CSRF-TOKEN": "{{ csrf_token() }}",
            },
          }
        )
        .then((res) => {
          Swal.fire({
            title: "Stolen",
            text: res.data.message ? res.data.message : "This Pets is Stolen",
            icon: "success",
          });
          setLoader(false);
          handleClose();
        })
        .catch((err) => {
          Swal.fire({
            title: "Stolen",
            text: err.response.data.message,
            icon: "error",
          });
          console.error(err);
          setLoader(false);
        });
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="form-wrapper"
      style={{ padding: "20px" }}
    >
      <CardElement />
      <button className="account-btn mt-5" type="submit">
        {loaders ? <Loader /> : "Pay Now"}
      </button>
    </form>
  );
};
// Stripe Code End

const SucriptionComponent = () => {
  const [products, setProducts] = useState([]);
  const [pageLoader, setPageLoader] = useState(false);
  const [loader, setLoader] = useState(false);
  const [id, setId] = useState();
  async function handleSubscription() {
    setPageLoader(true);
    const response = await axiosInstance.get("client/get/all/plans");
    setProducts(response.data?.data);
    setPageLoader(false);
  }
  useEffect(() => {
    handleSubscription();
  }, []);

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handlerBook = (item) => {
    setId(item?.id);
    handleShow();
  };

  const handlerPaypal = (id) => {
    try {
      setLoader(true);
      const formData = new FormData();
      formData.append("plan_id", id);
      axiosInstance
        .post("client/subscribe/to/plan/paypal", formData)
        .then((res) => {
          window.location.href = res?.data?.link;
          setLoader(false);
        })
        .catch((err) => {
          console.log(err, "err");
          setLoader(false);
        });
    } catch (err) {
      console.log(err, "err");
    }
  };

  return (
    <>
      <>
        <Modal show={show} onHide={handleClose} centered>
          <Modal.Header closeButton>
            <Modal.Title>Payment</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Tabs
              defaultActiveKey="Stripe"
              transition={false}
              id="noanim-tab-example"
              className="mb-3 d-flex justify-content-around align-items-center w-100"
            >
              <Tab eventKey="Stripe" title="Stripe">
                <Elements stripe={stripePromise}>
                  <CheckoutForm handleClose={handleClose} id={id} />
                </Elements>
              </Tab>
              <Tab eventKey="Paypal" title="Paypal">
                <div className="form-wrapper" style={{ padding: "20px" }}>
                  <button
                    className="account-btn mt-5"
                    onClick={() => handlerPaypal(id)}
                  >
                    {loader ? <Loader /> : "Paypal"}
                  </button>
                </div>
              </Tab>
            </Tabs>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <div className="inner-page-banner">
          <div className="breadcrumb-vec-btm">
            <img
              className="img-fluid"
              src="assets/images/bg/inner-banner-btm-vec.png"
              alt=""
            />
          </div>
          <div className="container">
            <div className="row justify-content-center align-items-center text-center">
              <div className="col-lg-6 align-items-center">
                <div className="banner-content">
                  <h1>Pricing Plan</h1>
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to={"/"}>Home</Link>
                      </li>
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                      >
                        Pricing Plan
                      </li>
                    </ol>
                  </nav>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="banner-img d-lg-block d-none">
                  <div className="banner-img-bg">
                    <img
                      className="img-fluid"
                      src="assets/images/bg/inner-banner-vec.png"
                      alt=""
                    />
                  </div>
                  <img
                    className="img-fluid"
                    src="assets/images/bg/inner-banner-img.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="h1-pricing-plan-area two pt-120 mb-120">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 d-flex justify-content-center">
                <div className="section-title1 text-center">
                  <span>
                    <img src="assets/images/icon/section-vec-l1.svg" alt="" />
                    Pricing plan
                    <img src="assets/images/icon/section-vec-r1.svg" alt="" />
                  </span>
                  <h2>Choose your perfect Plan</h2>
                </div>
              </div>
            </div>
            <div className="row mt-5">
              <div className="tab-content" id="nav-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="nav-profile"
                  role="tabpanel"
                  aria-labelledby="nav-profile-tab"
                >
                  {pageLoader ? (
                    <div className="d-flex justify-content-center align-items-center">
                      <OvalLoader />
                    </div>
                  ) : (
                    <div className="row justify-content-center g-lg-4 gy-5">
                      {products?.map((item, index) => {
                        return (
                          <div
                            className="col-lg-4 col-md-6 col-sm-10"
                            key={index}
                          >
                            <div className="pricing-card">
                              <img
                                className="price-card-vector"
                                src="assets/images/icon/price-card-bg.svg"
                                alt=""
                              />
                              <div className="title">
                                <h4>{item?.name}</h4>
                                <h2>
                                  <span className="currency">$</span>{" "}
                                  {item?.price}{" "}
                                  <span className="time">{item?.interval}</span>
                                </h2>
                              </div>
                              <ul>
                                <li>
                                  {item?.slug}
                                  <img
                                    src="assets/images/icon/pricing-check.svg"
                                    alt=""
                                  />
                                </li>
                                <li>
                                  {item?.description}
                                  <img
                                    src="assets/images/icon/pricing-check.svg"
                                    alt=""
                                  />
                                </li>
                              </ul>
                              <div className="book-now-btn cursor-pointer">
                                <a onClick={() => handlerBook(item)}>
                                  Book Now
                                </a>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default SucriptionComponent;
